import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { BiData } from '@wix/da-bi/pkg/events';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenuV2';
const MoreMenu = ({ isLoggedIn, className, menuClassName })=>{
    const { t } = useTranslation();
    const items = useMemo(()=>[
            {
                items: [
                    {
                        key: 'groups',
                        label: t('siteHeader.groups'),
                        link: Url.buildFromPath(URLS.GROUPS),
                        biData: BiData({
                            evid: 700,
                            link_name: 'groups',
                            link_url: Url.buildFromPath(URLS.GROUPS)
                        })
                    },
                    {
                        key: 'forum',
                        label: t('siteHeader.forum'),
                        link: Url.buildFromPath(URLS.FORUM),
                        biData: BiData({
                            evid: 700,
                            link_name: 'forum',
                            link_url: Url.buildFromPath(URLS.FORUM)
                        })
                    },
                    {
                        key: 'dreamup',
                        label: t('siteHeader.dreamup'),
                        link: Url.dreamupLink(),
                        newTag: 'purple',
                        target: isLoggedIn ? undefined : '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'dreamup',
                            link_url: Url.dreamupLink()
                        })
                    }
                ]
            },
            {
                items: [
                    {
                        key: 'whatsNew',
                        label: t('siteHeader.whatsNew'),
                        link: Url.to(URLS.TEAM),
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'whatsNew',
                            link_url: Url.to(URLS.TEAM)
                        })
                    },
                    {
                        key: 'betaTesting',
                        label: t('siteHeader.betaTesting'),
                        link: URLS.BETA_TESTING,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'betaTesting',
                            link_url: URLS.BETA_TESTING
                        })
                    },
                    {
                        key: 'monetize',
                        label: t('siteHeader.monetize'),
                        link: URLS.SHOP_TOP_NAV,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'deviantartsell',
                            link_url: URLS.SHOP_TOP_NAV
                        })
                    },
                    {
                        key: 'create-group',
                        label: t('siteHeader.createGroup'),
                        link: Url.to(URLS.GROUPS_CREATE),
                        biData: BiData({
                            evid: 700,
                            link_name: 'create-group',
                            link_url: Url.to(URLS.GROUPS_CREATE)
                        })
                    }
                ]
            }
        ], [
        t,
        isLoggedIn
    ]);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MoreMenu"
    }, /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        className: className,
        standardMenuProps: {
            className: menuClassName
        },
        popperManagerProps: {
            isInPopup: true
        },
        placement: "bottom-end",
        openOnHover: true,
        items: items,
        size: "large",
        variant: "main",
        icon: EllipsisIcon,
        "aria-label": t('siteHeader.more')
    }));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;

//# sourceMappingURL=MoreMenu.js.map